interface Props {
  children?: React.ReactNode;
}

const FullWidthPageContent: React.FC<Props> = ({ children }) => (
  <div className="content-container full-width">
    <section className="content-width">{children}</section>
  </div>
);

export default FullWidthPageContent;

